import { render, staticRenderFns } from "./table.vue?vue&type=template&id=5cd91bae&scoped=true&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"
import style0 from "../style/index.css?vue&type=style&index=0&id=5cd91bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd91bae",
  null
  
)

export default component.exports